import { ApplicationsDto } from '@core/services/dto';
import { formateTZtoTZ, formateUTCtoTZ } from '@shared/utils';

export class ApplicationsModel {
  applicants: { firstName: string; lastName: string; type: string }[];
  applicantsDisplay: string;
  applicationType = 'Retail';
  dateAssignedTo: string;
  dateViewed: string;
  products: string[];
  publicId: string;
  id: number;
  status: string;
  order: string;
  originatingChannel?: string;
  dateUpdated: Date;
  dateReceived: Date;
  completedDate: Date;

  constructor(dto: ApplicationsDto) {
    for (const prop in dto) {
      if (dto.hasOwnProperty(prop)) {
        if (prop === 'dateAssignedTo' || prop === 'dateViewed') {
          this[prop] = formateTZtoTZ(dto[prop]);
        } else {
          this[prop] = dto[prop];
        }
      }
    }
    this.products = [];
    this.applicants?.forEach(item => {
      item.type = 'Member';
    });
    // Create applicantsDisplay string
    if (this.applicants && this.applicants.length > 0) {
      this.applicantsDisplay = this.applicants
        .map(applicant => `${applicant.firstName} ${applicant.lastName}`)
        .join(', ');
    } else {
      this.applicantsDisplay = '';
    }
    dto.applicationProducts?.forEach(product => {
      this.products.push(` ${product?.ProductName}`);
    });
    this.originatingChannel = dto?.originatingChannel === 'InBranch' ? 'In-Branch' : dto?.originatingChannel;
    this.dateUpdated = formateUTCtoTZ(dto?.dateUpdated) ? new Date(formateUTCtoTZ(dto.dateUpdated)) : null;
    this.dateReceived = formateUTCtoTZ(dto?.dateReceived) ? new Date(formateUTCtoTZ(dto.dateReceived)) : null;
    this.completedDate = formateUTCtoTZ(dto?.completedDate) ? new Date(formateUTCtoTZ(dto.completedDate)) : null;
  }
}
